module.exports = __webpack_public_path__ + "static/media/md-watch.cd7f7038.svg";